import React, { useContext } from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { asRem } from 'lib/css';
import { AppContext } from './AppContext';
import { Pages } from './pages';

const BottomBarWrapper = styled.div`
  background: #13131a;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  padding: ${asRem(6)} ${asRem(8)} calc(${asRem(10)} + env(safe-area-inset-bottom, 0px));
  box-shadow:
    0 -4px 24px rgba(0, 0, 0, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.03);

  nav {
    max-width: ${asRem(960)};
    margin: 0 auto;

    ul {
      display: flex;
      align-items: stretch;
      justify-content: space-around;

      li {
        flex: 1;
        padding: 0;
        margin: 0;
        list-style: none;
        display: flex;
        justify-content: center;

        a.nav-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: ${asRem(4)};
          cursor: pointer;
          padding: ${asRem(8)} 0 ${asRem(6)};
          border-radius: ${asRem(12)};
          width: ${asRem(72)};
          transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
          text-decoration: none;
          position: relative;
          -webkit-tap-highlight-color: transparent;
          user-select: none;

          svg {
            width: ${asRem(22)};
            height: ${asRem(22)};
            stroke: rgba(255, 255, 255, 0.38);
            stroke-width: 1.8;
            fill: none;
            transition: stroke 0.25s ease;
          }

          span {
            font-size: ${asRem(11)};
            font-weight: 500;
            letter-spacing: 0.2px;
            color: rgba(255, 255, 255, 0.38);
            transition: color 0.25s ease;
          }

          /* Active state */
          &.active {
            background: rgba(164, 120, 240, 0.08);
          }

          &.active::before {
            content: '';
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
            width: ${asRem(20)};
            height: 2.5px;
            background: #a478f0;
            border-radius: 0 0 3px 3px;
            box-shadow: 0 2px 8px rgba(164, 120, 240, 0.18);
          }

          &.active svg {
            stroke: #a478f0;
            transform: translateY(-1px);
          }

          &.active span {
            color: #a478f0;
          }

          /* Hover on inactive */
          &.inactive:hover {
            background: rgba(255, 255, 255, 0.03);
          }

          &.inactive:hover svg {
            stroke: rgba(255, 255, 255, 0.55);
          }

          &.inactive:hover span {
            color: rgba(255, 255, 255, 0.55);
          }

          /* Press */
          &:active {
            transform: scale(0.95);
          }
        }
      }
    }
  }

  .version-name {
    display: none;
    opacity: 0.6;
    text-align: right;
    padding-right: ${asRem(10)};
    font-size: ${asRem(10)};
    color: #fff;
  }
`;

export const BottomBar = () => {
  const appContext = useContext(AppContext);

  return (
    <BottomBarWrapper>
      <nav>
        <ul>
          <li>
            <NavLink
              to="/"
              className={({ isActive }) => `nav-item ${isActive ? 'active' : 'inactive'}`}
              end
            >
              <svg viewBox="0 0 24 24">
                <path d="M3 12l9-8 9 8" />
                <path d="M5 10v9a1 1 0 001 1h3v-5h6v5h3a1 1 0 001-1v-9" />
              </svg>
              <span>Home</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to={Pages.staff.leave.month.balance.meta.urlFor({ month: 'current' })}
              className={({ isActive }) => `nav-item ${isActive ? 'active' : 'inactive'}`}
            >
              <svg viewBox="0 0 24 24">
                <rect x="3" y="4" width="18" height="16" rx="2" />
                <line x1="3" y1="10" x2="21" y2="10" />
                <line x1="8" y1="2" x2="8" y2="6" />
                <line x1="16" y1="2" x2="16" y2="6" />
              </svg>
              <span>Leaves</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to={Pages.staff.leave.create.meta.url}
              className={({ isActive }) => `nav-item ${isActive ? 'active' : 'inactive'}`}
            >
              <svg viewBox="0 0 24 24">
                <rect x="5" y="3" width="14" height="18" rx="2" />
                <line x1="9" y1="10" x2="15" y2="10" />
                <line x1="12" y1="7" x2="12" y2="13" />
              </svg>
              <span>Apply Leave</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to={Pages.staff.salary.meta.url}
              className={({ isActive }) => `nav-item ${isActive ? 'active' : 'inactive'}`}
            >
              <svg viewBox="0 0 24 24">
                <rect x="2" y="6" width="20" height="12" rx="2" />
                <circle cx="12" cy="12" r="3" />
                <path d="M2 10a2 2 0 002-2" />
                <path d="M20 10a2 2 0 012-2" />
                <path d="M2 14a2 2 0 012 2" />
                <path d="M20 14a2 2 0 002 2" />
              </svg>
              <span>Payslip</span>
            </NavLink>
          </li>
        </ul>
      </nav>
      {appContext.boot && (
        <div className="version-name">
          {'v'}
          {appContext.boot.version}
          {` (api v${appContext.boot.api_version})`}
        </div>
      )}
    </BottomBarWrapper>
  );
};

BottomBar.propTypes = {
};
